import filtersDisplayConfig from "./filtersDisplay.config";
import columnsRenderersConfig from "./columnsRenderers.config";
import AssetTypesMapping from '@/data/mappings/AssetTypes.map';
import apiPathsConfig from './apiPaths.config';
import availableActionsConfig from "./availableActions.config";
import availableListViewsConfig from "./availableListViews.config";
import listNamesConfig from "./listNames.config";

const resultsManipulationCallback = (resultItem) => {
  resultItem.assetType = AssetTypesMapping[resultItem.assetType];
}

const tableViewConfig = {
  loadingSkeleton: {
    type: 'withImage',
    count: 5
  }
}

const itemsListerConfig = {
  apiPathsConfig,
  resultsManipulationCallback,
  filtersDisplayConfig,
  columnsRenderersConfig,
  tableViewConfig,
  availableActionsConfig,
  availableListViewsConfig,
  ...listNamesConfig
}

export default itemsListerConfig;